// Enum of all the roles available in the web app
export enum Role {
    Teacher = 'teacher',
    Kid = 'kid'
}
